import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center bg-[#F8FAFC] px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-xl">
        <img src={LOGO_URL} alt="Haba Trans Logistique" className="h-10 w-auto object-contain" />
        <h1 className="mt-6 text-2xl font-extrabold tracking-tight text-slate-900">Espace administrateur</h1>
        <p className="mt-1 text-sm text-slate-600">Connectez-vous pour gérer les livraisons.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <Label className="font-mono text-[10px] uppercase tracking-wider text-slate-500">Email</Label>
            <div className="relative mt-2">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="direction@haba-trans.ca"
                className="h-12 pl-9"
                data-testid="login-email-input"
              />
            </div>
          </div>
          <div>
            <Label className="font-mono text-[10px] uppercase tracking-wider text-slate-500">Mot de passe</Label>
            <div className="relative mt-2">
              <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="h-12 pl-9"
                data-testid="login-password-input"
              />
            </div>
          </div>

          {error && (
            <p className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-medium text-[#DC2626]"
               data-testid="login-error">
              {error}
            </p>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="h-12 w-full bg-[#1E3A8A] text-base font-bold text-white hover:bg-[#172d6d]"
            data-testid="login-submit-button"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
